import { useEffect, useState } from "react";
import { api, formatDateTime } from "../lib/api";
import { useT } from "../i18n/I18nContext";
import { Bell, CheckCheck } from "lucide-react";

export default function NotificationsPage() {
  const t = useT();
  const [notifs, setNotifs] = useState([]);

  const load = async () => {
    const { data } = await api.get("/notifications");
    setNotifs(data);
  };
  useEffect(() => { load(); }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    await load();
  };

  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-8">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <div className="nv-label">{t("notif.label")}</div>
          <h1 className="font-heading text-3xl font-medium text-[#0F4C3A] mt-2" data-testid="notifications-title">{t("notif.title")}</h1>
        </div>
        <button onClick={markAll} data-testid="mark-all-read" className="px-4 py-2 text-sm border border-[#E2E8E4] rounded-md hover:bg-[#F8FAF9] inline-flex items-center gap-2">
          <CheckCheck className="w-4 h-4" /> {t("notif.mark_all")}
        </button>
      </div>
      <div className="nv-border bg-white rounded-md divide-y divide-[#E2E8E4]">
        {notifs.length === 0 && <div className="p-10 text-center text-[#94A3B8]">{t("notif.empty")}</div>}
        {notifs.map((n) => (
          <div key={n.id} className={`px-5 py-4 ${!n.read ? "bg-[#F0FDF4]" : ""}`} data-testid={`notification-${n.id}`}>
            <div className="flex items-start gap-3">
              <Bell className={`w-4 h-4 mt-1 ${!n.read ? "text-[#D4AF37]" : "text-[#94A3B8]"}`} />
              <div className="flex-1">
                <div className="font-medium text-[#0F4C3A]">{n.title}</div>
                <div className="text-sm text-[#475569] mt-1">{n.message}</div>
                <div className="text-xs text-[#94A3B8] mt-2">{formatDateTime(n.created_at)}</div>
              </div>
              {!n.read && (
                <button
                  onClick={async () => { await api.post(`/notifications/${n.id}/read`); await load(); }}
                  className="text-xs tracking-wider uppercase text-[#0F4C3A] hover:text-[#D4AF37]"
                >
                  {t("notif.mark_read")}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
